(function () {
  'use strict';

  // TODO: This needs to be reviewed for dead code
  angular.module('ringbaPortal')
    .controller('PingTreeTargetsController', PingTreeTargetsController);

  function PingTreeTargetsController(
    _,
    $filter,
    $scope,
    $interval,
    $timeout,
    $log,
    $state,
    $stateParams,
    $uibModal,
    $translate,
    accountsService,
    bsLoadingOverlayService,
    isMobileDevice,
    pingTreeTargetService,
    statsService,
    userSettingsService,
    columnsFetchService,
    csvExportService,
    toaster,
    utils
  ) {

    const vm = this;
    let timer;
    const currentAccountId = accountsService.currentAccountId;

    vm.userSettings = {};
    vm.columnSettings = pingTreeTargetService.columnSettings;
    vm.loading = true;
    vm.forceUnlink = false;

    vm.filterOptionsMap = {
      'All': function () {
        return true;
      },
      'Open': function (target) {
        return target.tStatus && target.tStatus.isAcceptingCalls;
      },
      'Concurrency Hit': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'ConcurrencyHit';
      },
      'Group Concurrency Hit': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'GroupConcurrencyHit';
      },
      'Capped': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'IsCapped';
      },
      'Group Capped': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'GroupIsCapped';
      },
      'Closed': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'IsClosed';
      },
      'Group Closed': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'GroupIsClosed';
      },
      'Ring Tree Closed': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'RingTreeIsClosed';
      },
      'Disabled': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'Disabled';
      },
      'Group Disabled': function (target) {
        return target.tStatus && !target.tStatus.isAcceptingCalls && target.tStatus.blockReason === 'GroupDisabled';
      }
    };

    vm.selectedOptionDropdown = 'All';

    vm.$onInit = onInit;
    vm.dropSuccess = dropSuccess;
    vm.toggleEnabled = toggleEnabled;
    vm.viewReporting = viewReporting;
    vm.confirmResetCapCounters = confirmResetCapCounters;
    vm.resetCapCounters = resetCapCounters;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDelete = confirmDelete;
    vm.cancelDelete = cancelDelete;
    vm.cancelModal = cancelModal;
    vm.setForceUnlink = setForceUnlink;
    vm.activateTargetActions = activateTargetActions;
    vm.duplicateTarget = duplicateTarget;

    vm.showForm = showForm;
    vm.hideForm = hideForm;

    vm.showReferences = showReferences;
    vm.hideReferences = hideReferences;

    vm.onTargetFilterSelected = onTargetFilterSelected;
    vm.exportToCSV = exportToCSV;

    vm.onSave = onSave;

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      vm.isBuyer = accountsService.isBuyer();
      vm.isMobileView = isMobileDevice;
      vm.createAccess = accountsService.hasAccess('PingTreeTarget', 'CREATE');

      vm.activeRingTreeTarget = null;
      vm.showSpecificRecordDetails = $stateParams.pingTreeTargetId;
      vm.pingTreeTargetIdToClone = $stateParams.sourcePingTreeTargetId;
      _setViewDetails(vm.showSpecificRecordDetails);

      _loadUserSettings().then(function () {
        return _loadData();
      });

      timer = $interval(function () {
        pingTreeTargetService.getTargets(currentAccountId, true, {
          targets: vm.currentTargets
        })
          .catch(_errorHandler);
      }, 15000);
    }

    function dropSuccess(e, item, collection) {
      // collection contains the current ordering of columns
      // after the drag and drop. We need to save the
      // collection in user settings under targets key
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          vm.userSettings = userSettings;
          if (!vm.userSettings.targets) {
            vm.userSettings.targets = {};
          }
          vm.userSettings.targets.columns = collection;
          return userSettingsService.saveUserSettings(vm.userSettings);
        });
    }

    function toggleEnabled(target) {
      if (vm.formActive) {
        return;
      }

      let promise;
      if (vm.isBuyer) {
        promise = pingTreeTargetService.buyerToggleTargetEnabled(currentAccountId, target.id);
      } else {
        const targetCopy = _.cloneDeep(target);
        targetCopy.enabled = !targetCopy.enabled;
        promise = pingTreeTargetService.updateTargetProperty(currentAccountId, target.id, {
          enabled: targetCopy.enabled
        });
      }
      return promise
        .then(function (updated) {
          target.enabled = updated.data.pingTreeTarget.enabled;
          // TODO: Send status for the updated target in the API response (just like in the stats targets API)
          // but for quick fix for a client handling the target status on the frontend
          _updateTargetStatsAfterEnableDisable(target, updated.data.stats);
          $scope.$broadcast('refreshAllTargets');
        })
        .catch(_errorHandler);
    }

    function viewReporting(target) {
      if (!vm.formActive) {
        return $state.go('dashboard.call-logs', {
          filterkey: 'targetName',
          filterdisplay: 'Target',
          filtervalue: target.name,
          filterisgroup: true
        });
      }
    }

    function confirmResetCapCounters(target) {
      if (!vm.formActive) {
        vm.targetForReset = target;
        vm.modalBodyText = $filter('translate')('RESET_COUNTERS_MODAL_BODY_WITH_NAME', { targetName: vm.targetForReset.name, target: 'Target' });
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/select-target/reset-target-counters.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function resetCapCounters() {
      return pingTreeTargetService.resetCallCounters(accountsService.currentAccountId, vm.targetForReset.id)
        .then(function () {
          toaster.pop('success', $filter('translate')('RESET_COUNTERS_SUCCESS'));
          vm.cancelModal();
          vm.targetForReset = null;
        })
        .catch(utils.errorHandler);
    }

    function confirmDeleteModal(target) {
      if (!vm.formActive) {
        vm.targetReferences = null;
        vm.targetForDelete = target;
        _getTargetReferences(target.id);
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/pingtreetargets/delete-ping-tree-target.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function confirmDelete() {
      return pingTreeTargetService.deleteTarget(currentAccountId, vm.targetForDelete.id, vm.forceUnlink).then(
        function () {
          _.remove(vm.currentTargets, function (target) {
            return target.id === vm.targetForDelete.id;
          });
          toaster.pop('success', $translate.instant('DELETE_PING_TREE_TARGET_SUCCESSFUL_MESSAGE'));
          cancelModal();
        }).catch(_errorHandler);
    }

    function setForceUnlink(value) {
      vm.forceUnlink = value;
    }

    function cancelDelete() {
      cancelModal();
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.targetForReset = null;
        vm.modalBodyText = null;
        vm.modal = null;
        vm.targetForDelete = null;
      }
    }

    function duplicateTarget(target) {
      if (!vm.formActive) {
        $state.go('dashboard.ringtreetarget.clone', { sourcePingTreeTargetId: target.id });
      }
    }

    function activateTargetActions(targetId) {
      vm.activeActionTargetId = vm.activeActionTargetId == targetId ? false : targetId;
    }

    function onSave(ringTreeTarget) {
      _loadData();

      // Don't hide form when specific record details are only being shown
      if (!vm.showSpecificRecordDetails) {
        hideForm(ringTreeTarget);
      }
    }

    function hideForm(ringTreeTarget) {
      if (ringTreeTarget) {
        ringTreeTarget.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
      vm.activeRingTreeTarget = null;

      if (vm.showSpecificRecordDetails || vm.pingTreeTargetIdToClone) {
        $state.go('dashboard.ringtreetargets');
      }
    }

    function showForm(ringTreeTarget, $event) {
      if ($event) {
        $event.preventDefault();
      }
      if (!vm.showSpecificRecordDetails) {
        if (vm.activeRingTreeTarget) hideForm(vm.activeRingTreeTarget);
        vm.activeRingTreeTarget = ringTreeTarget;
      }
      if (ringTreeTarget) {
        vm.showAddNewForm = false;
        ringTreeTarget.showEditForm = true;
      } else {
        vm.showAddNewForm = true;
      }
      vm.activeActionTargetId = false;
      vm.formActive = true;
    }

    function onTargetFilterSelected(option) {
      vm.selectedOptionDropdown = option;
    }

    function exportToCSV() {
      const targetsToExport = vm.currentTargets.filter(function (target) {
        return vm.filterOptionsMap[vm.selectedOptionDropdown](target);
      });
      const exportHeaders = Object.values(vm.columnSettings).map(col => ({
        label: $filter('translate')(col.displayName),
        value: col.stSort
      }));
      csvExportService.exportCSVFile(exportHeaders, targetsToExport, 'ring tree targets');
    }

    function showReferences(target) {
      if (!vm.formActive) {
        target.showReferences = true;
        if (!vm.showSpecificRecordDetails) vm.formActive = true;
        vm.activeRingTreeTarget = target;
        vm.activeActionShowCampaigns = false;
      }
    }

    function hideReferences(target) {
      delete target.showReferences;
      vm.formActive = false;
      vm.activeRingTreeTarget = null;
    }

    function _setViewDetails(showSpecificRecordDetails) {
      let loadingTranslation = 'PING_TREE_TARGETS_HEADER_LOADING';
      if (showSpecificRecordDetails) {
        loadingTranslation = 'PING_TREE_TARGET_HEADER_LOADING';
      } else {
        $translate('PING_TREE_TARGETS_PAGE_TITLE').then(function (translation) {
          vm.widgetTitle = translation;
        });
      }

      $translate(loadingTranslation).then(function (translation) {
        vm.loadingText = translation;
      });

      if (vm.pingTreeTargetIdToClone) {
        vm.showAddNewForm = true;
      }
    }

    function _updateTargetStatsAfterEnableDisable(target, updatedTargetStatsResponse) {
      const status = {
        isAcceptingCalls: target.enabled,
        blockReason: target.enabled ? '' : 'Disabled'
      };
      const usageStats = updatedTargetStatsResponse[utils.capFirstLetter(target.id)];
      statsService.normalizeStat(target, { status: status, usageStats: usageStats },  pingTreeTargetService.blockReasonTranslation);
    }

    function _buyerCanPauseTargets(targets) {
      //var canPause = true;
      return _.reduce(targets, function(canPause, t) {
        return canPause && vm.isBuyer && t && t.owner && t.owner.canPauseTargets;
      }, true);
      //return vm.isBuyer && target && target.owner && target.owner.canPauseTargets;
    }

    function _errorHandler(error) {
      utils.errorHandler(error);
      $log.getInstance('TargetsController').info('Error', error);
    }

    function _loadData() {
      if (vm.showSpecificRecordDetails) {
        _loadTarget($stateParams.pingTreeTargetId);
      } else {
        _loadTargets();
      }
    }

    function _loadTargets() {
      return pingTreeTargetService.getTargets(currentAccountId, true)
        .then(function (targets) {
          vm.currentTargets = targets;
          if (vm.isBuyer)
            vm.buyerCanPauseTargets = _buyerCanPauseTargets(targets);
          vm.loading = false;
        })
        .catch(_errorHandler);
    }

    function _loadTarget(ringTreeTargetId) {
      pingTreeTargetService.getTarget(accountsService.currentAccountId, ringTreeTargetId)
        .then(function (response) {
          vm.currentTargets = [response.data.pingTreeTarget];
          vm.widgetTitle = 'Ring Tree Target: ' + response.data.pingTreeTarget.name;
          vm.editingHighRateCostTarget = response.data.pingTreeTarget.highRateCost;
          if (vm.isBuyer)
            vm.buyerCanPauseTargets = _buyerCanPauseTargets([response.data.pingTreeTarget]);
          showForm(vm.currentTargets[0]);
          vm.loading = false;
        }).catch(utils.errorHandler);
    }

    function _loadUserSettings() {
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          vm.userSettings = userSettings;
          vm.columns = columnsFetchService.getColumnList(userSettings, pingTreeTargetService.defaultColumns, 'targets', vm.columnSettings);
        });
    }

    function _getTargetReferences(targetId) {
      vm.checkReferencesText = 'DELETE_PING_TREE_TARGET_MODAL_TARGET_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      pingTreeTargetService.getTargetReferences(currentAccountId, targetId).then(function (response) {
        // We're using timeout here to show the user the checking target references text
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.targetReferences = response.data;
        }, 800);
      }).catch(function () {
        vm.checkReferencesText = 'DELETE_PING_TREE_TARGET_MODAL_TARGET_CHECK_ASSOCIATION_ERROR_TEXT';
        bsLoadingOverlayService.stop();
      });
    }

    // When the DOM element is removed from the page,
    // AngularJS will trigger the $destroy event on
    // the scope. This gives us a chance to cancel any
    // pending timer that we may have.
    $scope.$on(
      '$destroy',
      function () {
        $interval.cancel(timer);
      }
    );

    // Watch the items displayed in the table, if there is an active item when it changes, hide the edit form and clear active item
    $scope.$watch('vm.displayTargets', function() {
      if (vm.activeRingTreeTarget) hideForm(vm.activeRingTreeTarget);
      if (vm.pingTreeTargetIdToClone) {
        vm.formActive = true;
      } else {
        vm.showAddNewForm = false;
        vm.formActive = false;
      }
    });
  }
})();
